import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { GetNotifiedButton } from '@components/EmailNotifications/GetNotifiedButton';
import { Countdown } from './Countdown';
import { CountdownContainer, fadeDown } from './shared';

export const AnimatedCountdown = ({
  mintStartTimestamp,
  hideCountdown,
  small,
  artistId,
  userId,
}: {
  mintStartTimestamp: number;
  hideCountdown: boolean;
  small?: boolean;
  artistId?: string;
  userId?: string;
}) => {
  return (
    <AnimatePresence>
      {!hideCountdown && (
        <CountdownContainer {...fadeDown} small={small}>
          <Countdown mintStartTimestamp={mintStartTimestamp} small={small} />
          {!!userId && !!artistId && (
            <GetNotifiedButton type="default" userId={userId} artistId={artistId} />
          )}
        </CountdownContainer>
      )}
    </AnimatePresence>
  );
};
